import { ChangeDetectorRef, Component } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-aggiungi-contatto-backoffice',
  templateUrl: './aggiungi-contatto-backoffice.component.html',
  styleUrl: './aggiungi-contatto-backoffice.component.css'
})
export class AggiungiContattoBackofficeComponent {

  constructor(private apiService: ApiService, private router: Router, private cdr: ChangeDetectorRef) { }  

  formContatti!: FormGroup;  

  ngOnInit(): void {    

    this.formContatti = new FormGroup({
      titolo: new FormControl(null, Validators.required),      
      descrizione: new FormControl(null, Validators.required)      
    })

  }

  onDescrizione(e: any) {    
    this.cdr.detectChanges();
  }

  onSubmit() {
    
    let contatto = {
      titolo: this.formContatti.get('titolo')?.value,
      descrizione: this.formContatti.get('descrizione')?.value
    }

    this.apiService.addContatto(contatto).subscribe({
      next: (data) => this.apiService.setContatti(),        
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {
        this.router.navigate(['/backoffice/contatti'])
      }
    })

  }

}
